import companyApi from "../company.api";

const useCompanyWhiteLabel = () => {
  const enableWhiteLabel = async () => {
    const resp = await companyApi.enableWhiteLabel();

    if (resp.isSuccess) {
      return resp.company;
    }

    return false;
  };

  const disableWhiteLabel = async () => {
    const resp = await companyApi.disableWhiteLabel();

    if (resp.isSuccess) {
      return resp.company;
    }

    return false;
  };

  return {
    enableWhiteLabel,
    disableWhiteLabel,
  };
};

export default useCompanyWhiteLabel;
